<template>
  <AppModal v-model="shouldShow" dialog-titel="Prisdetaljer">
    <div
      v-for="(row, index) in priceDetails.subscriptionRows"
      :key="index"
      class="border-b-md border-solid border-border-secondary first:mt-0 mt-32 pb-8"
    >
      <PricingPriceDetailsInfoItem
        :product-name="row.name"
        :product-info="row.info"
        :reg-price="row.regularPrice"
        :price="row.price"
        :price-unit="row.priceUnit"
        :data-allowance="row.dataAllowance"
        :regular-data-allowance="row.regularDataAllowance"
      />
    </div>

    <div
      v-if="priceDetails.deviceRow"
      class="border-b-md border-solid border-border-secondary mt-32 pb-8"
    >
      <PricingPriceDetailsInfoItem
        :product-name="priceDetails.deviceRow.name"
        :product-info="priceDetails.deviceRow.info"
        :reg-price="priceDetails.deviceRow.regularPrice"
        :price="priceDetails.deviceRow.price"
        :price-unit="priceDetails.deviceRow.priceUnit"
      />
    </div>

    <div
      v-if="priceDetails.periodRows.length > 0"
      class="border-b-md border-solid border-border-secondary mt-32 pb-8"
    >
      <PricingPriceDetailsInfoItem
        v-for="(periodRow, index) in priceDetails.periodRows"
        :key="index"
        :product-name="periodRow.label"
        :reg-price="periodRow.regularPrice"
        :price="periodRow.price"
        :price-unit="periodRow.priceUnit"
      />
    </div>

    <div class="mt-32">
      <PricingPriceDetailsInfoItem
        v-if="priceDetails.summary.totalSavings"
        product-name="Total rabatt"
        :price="priceDetails.summary.totalSavings"
        price-unit="kr"
      />

      <PricingPriceDetailsInfoItem
        v-if="priceDetails.summary.savingsPerMonth"
        product-name="Vilket motsvarar"
        :price="priceDetails.summary.savingsPerMonth"
        price-unit="kr/mån"
      />

      <PricingPriceDetailsInfoItem
        product-name="Minsta totalkostnad"
        :price="priceDetails.summary.minimumTotalCost"
        price-unit="kr"
      />
    </div>

    <slot />
  </AppModal>
</template>

<script lang="ts" setup>
import type { PriceModalResult } from '~/models/pricing/PriceDetailsModalTypes.model';

type Props = {
  priceDetails: PriceModalResult;
};

defineProps<Props>();

const shouldShow = defineModel<boolean>();
</script>
